import { render } from "./TableListAlternative.vue?vue&type=template&id=04c26cba"
import script from "./TableListAlternative.vue?vue&type=script&lang=js"
export * from "./TableListAlternative.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__